import React from 'react'

const CustomTitle = ({title,...props}) => {
  return (
    <div className={`customTitle ${props.className}`}>{title} <hr /></div>
  )
}

export default CustomTitle